<template>
    <div class="col-xl-12 text-start">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0 p-0">
                    <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon4"
                        :aria-expanded="isActive2 ? 'true' : 'false'" aria-controls="collapseicon4"
                        :class="[isActive2 ? 'active' : '', 'collapsible']" v-on:click="toggle2">Specific skills</button>
                </h5>
            </div>
            <div :class="[isActive2 ? 'block' : 'none', 'content']" v-show="isActive2">
                <div class="card-body animate-chk">
                    <label class="d-block" for="chk-ani19">
                        <input class="checkbox_animated" id="chk-ani19" type="checkbox">HTML,scss & sass
                    </label>
                    <label class="d-block" for="chk-ani20">
                        <input class="checkbox_animated" id="chk-ani20" type="checkbox">Javascript
                    </label>
                    <label class="d-block" for="chk-ani21">
                        <input class="checkbox_animated" id="chk-ani21" type="checkbox">Node.js
                    </label>
                    <label class="d-block" for="chk-ani22">
                        <input class="checkbox_animated" id="chk-ani22" type="checkbox">Gulp & Pug
                    </label>
                    <label class="d-block mb-0" for="chk-ani23">
                        <input class="checkbox_animated" id="chk-ani23" type="checkbox">Angular.js
                    </label>
                </div>
                <button class="btn btn-block btn-primary text-center" type="button">All Skills</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isActive2: true,
        }
    },
    methods: {
        toggle2() {
            this.isActive2 = !this.isActive2
        },
    }
}
</script>
